// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__3D1dS","repeat":"repeat__NFkAu"};